module.exports = __webpack_public_path__ + "img/logo.493cf23e.png";